// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3IQQl","marginCheckbox":"styles_marginCheckbox__3k0_W","notesText":"styles_notesText__3VGwK","tipContainerMargin":"styles_tipContainerMargin__uMmCe"};